import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material"
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { Stringable, StringableValues } from "../../../../../common/stringable.decorator"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { MustStringable } from "../../../../../Interfaces/MustStringable"
import { DialogService, VisiteService } from "../../../../../services"
const KEY = 'visite-formulaires-listing'

@Component({
  selector: 'atyl-visite-formulaires-listing',
  templateUrl: './visite-formulaires-listing.component.html',
  styleUrls: ['./visite-formulaires-listing.component.scss']
})
@Stringable({
  path: "views/partials/content/listing/visite-formulaires-listing",
  key: KEY,
})
export class VisiteFormulairesListing extends BaseDialogComponent implements OnInit, MustStringable {

    visite: any
    actions: any[] = [];
    selectedActions: any[] = [];
    droitsObjets: any;
    
    @StringableValues(KEY) strings: any
    constructor(
        changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<VisiteFormulairesListing>,
        private visiteService: VisiteService,
        private _snackBar: MatSnackBar,
        dialogService: DialogService,
    ) {
        super(dialogRef, dialogService, changeDetectorRef)
    }

    ngOnInit() {
        if(this.data.droitsObjets != undefined)
            this.droitsObjets = this.data.droitsObjets
        if (this.data.visite) {
            this.visite = this.data.visite
            this.actions = this.setObjectUserRights(this.data.visite.consultation.type.actions,"formulaire");
        }
    }

    selectOrRemoveAction(action: any) {
        console.log(action)
        if (this.selectedActions.indexOf(action) > -1) {
        this.selectedActions.splice(this.selectedActions.indexOf(action), 1)
        } else {
        this.selectedActions.push(action)
        }
        this.changeDetectorRef.detectChanges()
    }

    submitSelectedActionList() {
        console.log(this.visite, this.idFiy(this.selectedActions))
        this.visiteService
        .addFormsToVisite(this.visite.ID, this.idFiy(this.selectedActions), { tiersId: this.visite.tiers.ID }).subscribe(
            (res: JSONRpcResponse) => {
            if (res.result) {
                this._snackBar.open('Formulaires ajoutés avec succès', 'Fermer', {
                duration: 2000,
                })
                this.dialogRef.close(this.visite)
            }

            }
        )
    }

    idFiy(actions: any[]): number[] {
        return actions.map(action => action.ID)
    }

    setObjectUserRights(obj: any | any[], type: string) {
        if (Array.isArray(obj)) {
            obj.forEach((item: any) => {
                item = this.applyRightsObj(item, type);
            });
        } else {
            obj = this.applyRightsObj(obj, type);
        }
        return obj;
    }
    
    applyRightsObj(obj: any, type: string) {
        let rg: any = {
            r: true,
            w: true,
            x: true
        };
        let key = null;
        
        switch (type) {
            case "formulaire":
               if (obj.CodeForm!=undefined  )
                key = obj.CodeForm;
                break;
        }
        if (this.droitsObjets != undefined && this.droitsObjets[type] != undefined) {
            if (this.droitsObjets[type][key] != undefined) {
                rg = this.droitsObjets[type][key];
            }
        }
    
        obj.droitsObjets = rg;
    
        // Si l'objet est éditable, vérifier s'il est modifiable
        if (obj.editable == undefined || obj.editable) {
            obj.editable = rg.w;
        }
    
        return obj;
    }
}
